export class GuestSession {
  http;

  constructor(http) {
    this.http = http;
  }

  /**
   * Initialize a new anonymous guest session.
   * @param {{ initialDraft?: Record<string, any>, metadata?: Record<string, any> }} data
   */
  createSession = async (data = {}) => {
    const res = await this.http.instance.post("/api/core/auth/guest-session", data);
    return res.data;
  };

  /**
   * Retrieve guest session metadata and saved draft state.
   * @param {string} token
   */
  getSession = async (token) => {
    const res = await this.http.instance.get("/api/core/auth/guest-session", {
      headers: { "X-Guest-Session": token },
    });
    return res.data;
  };

  /**
   * Persist or update draft state for the guest session.
   * @param {string} token
   * @param {string} draftType
   * @param {Record<string, any>} draftData
   */
  updateDraft = async (token, draftType, draftData) => {
    const res = await this.http.instance.put(
      "/api/core/auth/guest-session/draft",
      { draftType, draftData },
      { headers: { "X-Guest-Session": token } }
    );
    return res.data;
  };

  /**
   * Claim and migrate the guest session to the current authenticated user.
   * @param {string} token
   * @param {boolean} createApplication
   */
  claimSession = async (token, createApplication = true) => {
    const res = await this.http.instance.post("/api/core/auth/guest-session/claim", {
      sessionToken: token,
      createApplication,
    });
    return res.data;
  };
}

export default GuestSession;

